import { render, staticRenderFns } from "./ImageWidgetPanel.vue?vue&type=template&id=82fc35f8&scoped=true"
import script from "./ImageWidgetPanel.vue?vue&type=script&lang=js"
export * from "./ImageWidgetPanel.vue?vue&type=script&lang=js"
import style0 from "./ImageWidgetPanel.vue?vue&type=style&index=0&id=82fc35f8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fc35f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82fc35f8')) {
      api.createRecord('82fc35f8', component.options)
    } else {
      api.reload('82fc35f8', component.options)
    }
    module.hot.accept("./ImageWidgetPanel.vue?vue&type=template&id=82fc35f8&scoped=true", function () {
      api.rerender('82fc35f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/editor/settingPanel/ImageWidgetPanel.vue"
export default component.exports